import React, { useState, useEffect } from 'react';
import {
  Box, TextField, Button, CircularProgress, Snackbar, MenuItem, Grid,
  FormControlLabel, Checkbox, Typography, Divider,
  Autocomplete,
  Switch
} from "@mui/material";
import MuiAlert from '@mui/material/Alert';
import { authenticationService } from "src/services";
import { get, multy_post } from 'src/services/httpClient.service';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

// Package duration options (in months) shown in the dropdown
const PACKAGE_DURATION_OPTIONS = [1, 2, 3, 6, 12];

const AddUser = (props) => {
  const { showSnackbar } = useSnackbar();
  const { vendorId, franchiseId, companyId, operatorId } = authenticationService.getVendorFranchiseIds();
  const { selectedLCOId, selectedLCOName, selectedLCOFranchiseId } = authenticationService.getSelectedLCO();
  const APIURL = process.env.REACT_APP_BASE_API_URL;
  const accountType = localStorage.getItem('accountType');
  const companyEmail = localStorage.getItem('companyEmail');
  
  // Get selected franchise from localStorage
  const selectedFranchise = JSON.parse(localStorage.getItem('selectedFranchise') || '{}');
  const franchiseCity = selectedFranchise?.city || selectedFranchise?.area || '';
  const [billingTaxTypes, setBillingTaxTypes] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [addressProofFile, setAddressProofFile] = useState(null);
  const [addressProofError, setAddressProofError] = useState('');

  //http://localhost:8081/api/billing-tax-type/vendor/jdfs-kjd94-sdjjdl-uifel-ydfnl/getAll
  const billingtaxtype = async () => {
    try {
      const res = await get(
        `${APIURL}/api/billing-tax-type/vendor/${vendorId}/getAll`
      );

      console.log("billingtype", res);

      if (res?.success && res?.data) {
        setBillingTaxTypes(res.data);
      }
    } catch (error) {
      console.error("Error fetching billing tax types", error);
    }
  };
 
  useEffect(() => {
    billingtaxtype();
  }, []);

  const [formValues, setFormValues] = useState({
    firstName: '',
    lastName: '',
    email: '',
    username: '',
    password: '',
    phone: '',
    landlineNumber: '',
    aadharNumber: '',
    address: '',
    address2: '',
    billingAddress1: '',
    billingAddress2: '',
    status: 'ACTIVE',
    vendorId: vendorId,
    franchiseId: franchiseId,
    deviceStatus: 'ACTIVE',
    fingerprintStatus: 'ENABLED',
    areaId: '',
    billingAreaId: '',

    //acn extra fields
    // business: '',
    // customerNumber: '',
    // dateOfBirth: '',
    // gender: '',
    // agent: '',
    // roads: '',
    // buildings: '',
    // wing: '',
    // floor: '',
    // flatNo: '',
    // memberType: '',
    // group: '',
    // postcode: '',
    // remarks: '',
    // gstNo: '',
    // panNo: '',
    // latitude: '',
    // longitude: '',
    isRental: false,
    autoRenewal: false,

    prepaidCustomer: false,
    billingTaxType: '',
    billDate: '',
    dueDate: '',
    servicePerson: '',
    collectionPerson: '',

    registeredDate: '',
    connectionDate: '',
    fixBillAmount: '',
    billingType: '',
    openingAmount: '',
    openingType: '',

    isFree: false,
    isStb: false,
    isApk: false,
    collectionDate: '',
    oneTimeCharges: '',
    securityDeposit: '',
    creditLimit: '',

    // NEW: package duration in months (1, 2, 3, 6, 12)
    packageDuration: '',
  });

  const [formErrors, setFormErrors] = useState({
    username: '',
    password: '',
    email: '',
    phone: '',
    landlineNumber: '',
    aadharNumber: '',
    address: '',
    address2: '',
    billingAddress1: '',
    billingAddress2: '',
    fingerprintStatus: '',
    areaId: '',
    billingAreaId: '',
  });

  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [idProofFile, setIdProofFile] = useState(null);
  const [fileError, setFileError] = useState('');
  const [copyAddress, setCopyAddress] = useState(false);
  
  const [areaList, setAreaList] = useState([]);
  const [filteredAreaList, setFilteredAreaList] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedBillingArea, setSelectedBillingArea] = useState(null);

  //passwordcontrol
  const [hasCustomPasswordAccess, setHasCustomPasswordAccess] = useState(false);
  
  const fetchApplicationConfig = async () => {
    try {
      const response = await get(
        `${APIURL}/api/application-config/vendor/${vendorId}`
      );
  
      setHasCustomPasswordAccess(
        response?.hasCustomPasswordAccess || false
      );
  
      console.log(
        "hasCustomRegCodeAccess",
        response?.hasCustomPasswordAccess
      );
    } catch (error) {
      console.error("Error fetching application config", error);
    }
  };
  
  useEffect(() => {
    fetchApplicationConfig();
  }, []);

  /* =========================
       API TO Fetch AreaList
    ========================= */
  const fetchAreas = async () => {
    try {
      const response = await get(
        `${APIURL}/api/miscellaneous/area/vendor/${vendorId}/findAll`
      );
      
      if (response && response.data) {
        const allAreas = response.data;
        setAreaList(allAreas);
        console.log('allAreas',allAreas)
        
        // Filter areas based on franchise city
        let filteredAreas = [];
        let autoSelectedArea = null;
        
       /*  if (franchiseCity) {
          filteredAreas = allAreas.filter(area => {
            const matchesCity = area.cityName?.toLowerCase().includes(franchiseCity.toLowerCase()) ||
                               area.name?.toLowerCase().includes(franchiseCity.toLowerCase());
            
            // Try to find an exact match for auto-selection
            if (!autoSelectedArea && matchesCity) {
              // Check for more specific matches
              if (area.cityName?.toLowerCase() === franchiseCity.toLowerCase()) {
                autoSelectedArea = area;
              } else if (area.name?.toLowerCase() === franchiseCity.toLowerCase()) {
                autoSelectedArea = area;
              }
            }
            
            return matchesCity;
          });
          
          // If no exact match found, use the first filtered area
          if (!autoSelectedArea && filteredAreas.length > 0) {
            autoSelectedArea = filteredAreas[0];
          }
          
          setFilteredAreaList(filteredAreas);
        } else {
          // If no franchise city found, show all areas
          filteredAreas = allAreas;
          setFilteredAreaList(allAreas);
        } */
        filteredAreas = allAreas;
        setFilteredAreaList(allAreas);
        autoSelectedArea = null;
        // Auto-select area if found
        if (autoSelectedArea) {
          setSelectedArea(autoSelectedArea);
          setSelectedBillingArea(autoSelectedArea);
          
          setFormValues(prev => ({
            ...prev,
            areaId: autoSelectedArea.id,
            billingAreaId: autoSelectedArea.id
          }));
        }
      }
    } catch (error) {
      console.error("Error fetching areas", error);
      showSnackbar('Failed to fetch area list', 'error');
    }
  };

  useEffect(() => {
    fetchAreas();
  }, [franchiseCity]);

  useEffect(() => {
    if (copyAddress) {
      setFormValues(prev => ({
        ...prev,
        billingAddress1: prev.address,
        billingAddress2: prev.address2,
        billingAreaId: prev.areaId
      }));
      
      // Also update billing area selection
      if (selectedArea) {
        setSelectedBillingArea(selectedArea);
      }
    }
  }, [copyAddress, selectedArea, formValues.address, formValues.address2, formValues.areaId]);

  const handleChange = (e) => {
     const field =
    e.target.name ||
    e.target.id ||
    e.target.getAttribute("data-field");

  const value = e.target.value;

  setFormValues((prev) => ({
    ...prev,
    [field]: value,
  }));

    let errors = { ...formErrors };

    if (field  === 'email') {
      const lowerCaseValue = value.toLowerCase();
      setFormValues({ ...formValues, [field ]: lowerCaseValue });

      const emailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
      errors.email = emailRegex.test(lowerCaseValue)
        ? ''
        : 'Enter a valid email address (lowercase only)';
      setFormErrors(errors);
      return;
    }

    if (field  === 'username') {
      const usernameRegex = /^[A-Za-z0-9_@.]{4,50}$/;
      errors.username = usernameRegex.test(value)
        ? ''
        : 'Username must be at least 4 letters';
    }

    if (field  === 'password') {
      if (value.trim() === '') {
        errors.password = '';
      } else {
        const passwordRegex =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,12}$/;
        errors.password = passwordRegex.test(value)
          ? ''
          : 'Password must be 8-12 characters with uppercase, lowercase, number & special character';
      }
    }
    
    if (field  === 'phone') {
      const phoneRegex = /^\d{10}$/;
      errors.phone = phoneRegex.test(value)
        ? ''
        : 'Phone number must be exactly 10 digits';
    }

    // LANDLINE NUMBER VALIDATION (Optional, but validate format if provided)
    if (field  === 'landlineNumber') {
      if (value.trim() === '') {
        errors.landlineNumber = ''; // Optional field
      } else {
        // Allows formats: 0123456789, 012-3456789, 012345-67890, (012)3456789
        const landlineRegex = /^(\d{10,12}|(\d{2,5}[-]?\d{6,8})|\(\d{2,5}\)\d{6,8})$/;
        errors.landlineNumber = landlineRegex.test(value)
          ? ''
          : 'Enter a valid landline number (e.g., 0123456789 or 012-3456789)';
      }
    }

    if (field  === 'aadharNumber') {
      if (value.trim() === '') {
        errors.aadharNumber = '';
      } else {
        const aadharRegex = /^\d{12}$/;
        errors.aadharNumber = aadharRegex.test(value)
          ? ''
          : 'Aadhaar number must be exactly 12 digits';
      }
    }

    if (field  === 'address') {
      errors.address = !value.trim() ? 'Address is required' : '';
    }
    
    if (field  === 'address2') {
      errors.address2 = !value.trim() ? 'Address Landmark is required' : '';
    }

    if (field  === 'billingAddress1') {
      errors.billingAddress1 = !value.trim() ? 'Address is required' : '';
    }
    
    if (field  === 'billingAddress2') {
      errors.billingAddress2 = !value.trim() ? 'Address Landmark is required' : '';
    }

    setFormErrors(errors);
  };

  const handleClose = () => {
    props.onClose();
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];
    if (!allowedTypes.includes(file.type)) {
      setFileError('Only PDF, JPG, and PNG files are allowed.');
      setIdProofFile(null);
    } else {
      setFileError('');
      setIdProofFile(file);
    }
  };

  const handleAddressProofUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png'];

  if (!allowedTypes.includes(file.type)) {
    setAddressProofError('Only PDF, JPG, and PNG files are allowed.');
    setAddressProofFile(null);
  } else {
    setAddressProofError('');
    setAddressProofFile(file);
  }
};

  const onSubmit = async () => {
    const errors = {
      phone: !formValues.phone.match(/^[6-9]\d{9}$/) ? 'Enter a valid 10-digit phone number' : '',
      landlineNumber: (() => {
        if (!formValues.landlineNumber || formValues.landlineNumber.trim() === '') return '';
        const landlineRegex = /^(\d{10,12}|(\d{2,5}[-]?\d{6,8})|\(\d{2,5}\)\d{6,8})$/;
        return landlineRegex.test(formValues.landlineNumber) ? '' : 'Enter a valid landline number';
      })(),
      aadharNumber: formValues.aadharNumber && !formValues.aadharNumber.match(/^\d{12}$/) ? 'Aadhaar number must be exactly 12 digits' : '',
      email: formValues.email && formValues.email.trim() !== ''
        ? !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email)
          ? 'Enter a valid email address'
          : ''
        : '',
      username: !/^[A-Za-z0-9_@.]{4,50}$/.test(formValues.username)
        ? 'Username must be at least 4 letters'
        : '',
      password: formValues.password && formValues.password.trim() !== ''
        ? !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,12}$/.test(formValues.password)
          ? 'Password must be 8 characters with uppercase, lowercase, number & special character'
          : ''
        : '',
      address: !formValues.address.trim() ? 'Address is required' : '',
      address2: !formValues.address2.trim() ? 'Address Landmark is required' : '',
      fingerprintStatus: !formValues.fingerprintStatus ? 'Fingerprint Status is required' : '',
      billingAddress1: !copyAddress && !formValues.billingAddress1.trim() ? 'Address is required' : '',
      billingAddress2: !copyAddress && !formValues.billingAddress2.trim() ? 'Address Landmark is required' : '',
      areaId: !formValues.areaId ? 'Area is required' : '',
      billingAreaId: !formValues.billingAreaId ? 'Billing Area is required' : '',
      // To make package duration mandatory, uncomment the next line
      // packageDuration: !formValues.packageDuration ? 'Package duration is required' : '',
    };

    setFormErrors(errors);

    if (Object.values(errors).some(error => error !== '')) {
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();

      const userData = {
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        userName: formValues.username,
        email: formValues.email,
        userPassword: formValues.password,
        phone: formValues.phone,
        landlineNumber: formValues.landlineNumber || null,
        aadharNumber: formValues.aadharNumber,
        address: formValues.address,
        address2: formValues.address2,
        areaId: formValues.areaId,
        billingAddress1: formValues.billingAddress1,
        billingAddress2: formValues.billingAddress2,
        billingAreaId: formValues.billingAreaId,
        vendorId: vendorId,
        franchiseId: selectedLCOFranchiseId,
        status: formValues.status,
        deviceStatus: formValues.deviceStatus,
        fingerprintStatus: formValues.fingerprintStatus,
        createdBy: operatorId,

        //acn addtional fiels
        // business: formValues.business,
        // customerNumber: formValues.customerNumber,
        // dateOfBirth: formValues.dateOfBirth,
        // gender: formValues.gender,
        // agent: formValues.agent,
        // roads: formValues.roads,
        // buildings: formValues.buildings,
        // wing: formValues.wing,
        // floor: formValues.floor,
        // flatNo: formValues.flatNo,
        // memberType: formValues.memberType,
        // group: formValues.group,
        // postcode: formValues.postcode,
        // gstNo: formValues.gstNo,
        // panNo: formValues.panNo,
        // latitude: formValues.latitude,
        // longitude: formValues.longitude,
        // remarks: formValues.remarks,
        
        isRental: formValues.isRental,
        autoRenewal: formValues.autoRenewal,

        prepaidCustomer: formValues.prepaidCustomer,
        billingTaxType: formValues.billingTaxType,
        billDate: formValues.billDate,
        dueDate: formValues.dueDate,
        servicePerson: formValues.servicePerson,
        collectionPerson: formValues.collectionPerson,
        registeredDate: formValues.registeredDate,
        connectionDate: formValues.connectionDate,
        fixBillAmount: formValues.fixBillAmount,
        billingType: formValues.billingType,
        openingAmount: formValues.openingAmount,
        openingType: formValues.openingType,
        isFree: formValues.isFree,
        isStb: formValues.isStb,
        isApk: formValues.isApk,
        collectionDate: formValues.collectionDate,
        oneTimeCharges: formValues.oneTimeCharges,
        securityDeposit: formValues.securityDeposit,
        creditLimit: formValues.creditLimit,

        // NEW: package duration (months) sent to backend
        packageDuration: formValues.packageDuration ? Number(formValues.packageDuration) : null,
      };

      console.log('userdata', userData)

      if(accountType.trim() !== "OWNER") {
        userData['assignedTo'] = selectedLCOId
      }
      console.log("userData:::", userData)
      formData.append('user', new Blob([JSON.stringify(userData)], {
        type: 'application/json'
      }));

      if (idProofFile) {
        formData.append('proofDocument', idProofFile);
      }

      if (addressProofFile) {
  formData.append('addressProofDocument', addressProofFile);
}

      const response = await multy_post(`${APIURL}/api/subscriber/register`, formData);
      console.log('formData',formData)
      setLoading(false);
      
      if (response.responseCode === "200") {
        props.fetchUserData();
        showSnackbar('Successfully Registered', 'success');
        props.onClose();
      } else {
        console.log("response"+response)
        showSnackbar(response.responseMessage, 'error');
      }
    } catch (error) {
      console.log("catch response"+error)
      setLoading(false);
      showSnackbar('Something went wrong', 'error');
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={2}>
        {/* User Details Section */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>Subscriber Details</Typography>
          <Divider />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField fullWidth id="firstName" label="First Name" value={formValues.firstName} onChange={handleChange} autoComplete="off" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField fullWidth id="lastName" label="Last Name" value={formValues.lastName} onChange={handleChange} autoComplete="off" />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            id="username"
            label="Username"
            value={formValues.username}
            onChange={handleChange}
            error={!!formErrors.username}
            helperText={formErrors.username}
            autoComplete="off"
            inputProps={{ minLength: 4 }}
          />
        </Grid>
        
        {hasCustomPasswordAccess && (
          <Grid item xs={12} sm={4}>
            <TextField
  fullWidth
  id="password"
  label="Password"
  type={showPassword ? "text" : "password"}
  value={formValues.password}
  onChange={handleChange}
  error={!!formErrors.password}
  helperText={formErrors.password}
  autoComplete="new-password"
  inputProps={{ minLength: 8, maxLength: 12 }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <IconButton
          onClick={() => setShowPassword((prev) => !prev)}
          edge="end"
        >
          {showPassword ? (
            <VisibilityOffIcon />
          ) : (
            <VisibilityIcon />
          )}
        </IconButton>
      </InputAdornment>
    ),
  }}
/>
          </Grid>
        )}
        
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            id="email"
            label="Email"
            value={formValues.email}
            onChange={handleChange}
            error={!!formErrors.email}
            helperText={formErrors.email}
            autoComplete="off"
          />
        </Grid>
        
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            id="phone"
            label="Phone"
            value={formValues.phone}
            onChange={handleChange}
            error={!!formErrors.phone}
            helperText={formErrors.phone}
            autoComplete="off"
          />
        </Grid>

        {/* LANDLINE NUMBER FIELD */}
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            id="landlineNumber"
            label="Landline Number (Optional)"
            value={formValues.landlineNumber}
            onChange={handleChange}
            error={!!formErrors.landlineNumber}
            helperText={formErrors.landlineNumber || "e.g., 0123456789 or 012-3456789"}
            autoComplete="off"
            placeholder="Enter landline number with STD code"
          />
        </Grid>
        
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            id="aadharNumber"
            label="Aadhaar Number (Optional)"
            value={formValues.aadharNumber}
            onChange={handleChange}
            error={!!formErrors.aadharNumber}
            helperText={formErrors.aadharNumber || "12 digits, optional"}
            autoComplete="off"
            placeholder="Enter 12-digit Aadhaar"
            inputProps={{ maxLength: 12 }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormControlLabel
            control={
              <Switch
                checked={formValues.isRental || false}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    isRental: e.target.checked
                  })
                }
              />
            }
            label="Is Rental"
            sx={{ mt: 1 }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <FormControlLabel
            control={
              <Switch
                checked={formValues.autoRenewal || false}
                onChange={(e) =>
                  setFormValues({
                    ...formValues,
                    autoRenewal: e.target.checked
                  })
                }
              />
            }
            label="Auto Renewal"
            sx={{ mt: 1 }}
          />
        </Grid>

        {/* Package Section (NEW) - visible for all companies */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Package</Typography>
          <Divider />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            select
            fullWidth
            id="packageDuration"
            name="packageDuration"
            label="Package Duration"
            value={formValues.packageDuration}
            onChange={handleChange}
            helperText="Select the validity period of the package"
          >
            {PACKAGE_DURATION_OPTIONS.map((months) => (
              <MenuItem key={months} value={months}>
                {months} {months === 1 ? 'Month' : 'Months'}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Installation Address Section */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Installation Address</Typography>
          <Divider />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField fullWidth id="address" label="Address" value={formValues.address} onChange={handleChange} error={!!formErrors.address} helperText={formErrors.address} autoComplete="off" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField fullWidth id="address2" label="Landmark/Village" value={formValues.address2} onChange={handleChange} autoComplete="off" error={!!formErrors.address2} helperText={formErrors.address2} />
        </Grid>

        <Grid item xs={12} md={4}>
          <Autocomplete
            options={filteredAreaList}
            loading={!filteredAreaList.length}
            value={selectedArea}
            getOptionLabel={(option) =>
              `${option.name} / ${option.cityName} / ${option.stateName} / ${option.countryName} / ${option.zipCode}`
            }
            isOptionEqualToValue={(option, value) =>
              String(option.id) === String(value.id)
            }
            onChange={(_, newValue) => {
              setSelectedArea(newValue);
              setFormValues(prev => ({
                ...prev,
                areaId: newValue ? newValue.id : ''
              }));
              
              // If "Same as Installation Address" is checked, update billing too
              if (copyAddress) {
                setSelectedBillingArea(newValue);
                setFormValues(prev => ({
                  ...prev,
                  billingAreaId: newValue ? newValue.id : ''
                }));
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Area"
                fullWidth
                error={!!formErrors.areaId}
                helperText={formErrors.areaId || (selectedArea ? `Auto-selected for ${franchiseCity}` : '')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {!filteredAreaList.length && <CircularProgress size={18} />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>

        {/* Billing Address Section */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Billing Address</Typography>
          <Divider />
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={copyAddress}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setCopyAddress(checked);
                  
                  if (checked && selectedArea) {
                    setSelectedBillingArea(selectedArea);
                    setFormValues(prev => ({
                      ...prev,
                      billingAddress1: prev.address,
                      billingAddress2: prev.address2,
                      billingAreaId: prev.areaId
                    }));
                  }
                }}
              />
            }
            label="Same as Installation Address"
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            id="billingAddress1"
            label="Address"
            value={formValues.billingAddress1}
            onChange={handleChange}
            disabled={copyAddress}
            error={!!formErrors.billingAddress1}
            helperText={formErrors.billingAddress1}
            autoComplete="off"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            id="billingAddress2"
            label="Landmark/Village"
            value={formValues.billingAddress2}
            onChange={handleChange}
            disabled={copyAddress}
            autoComplete="off"
            error={!!formErrors.billingAddress2} 
            helperText={formErrors.billingAddress2}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Autocomplete
            options={filteredAreaList}
            loading={!filteredAreaList.length}
            value={selectedBillingArea}
            getOptionLabel={(option) =>
              `${option.name} / ${option.cityName} / ${option.stateName} / ${option.countryName} / ${option.zipCode}`
            }
            isOptionEqualToValue={(option, value) =>
              String(option.id) === String(value.id)
            }
            onChange={(_, newValue) => {
              setSelectedBillingArea(newValue);
              setFormValues(prev => ({
                ...prev,
                billingAreaId: newValue ? newValue.id : ''
              }));
            }}
            disabled={copyAddress}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Billing Area"
                fullWidth
                error={!!formErrors.billingAreaId}
                helperText={formErrors.billingAreaId || (selectedBillingArea && copyAddress ? 'Same as Installation Address' : '')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {!filteredAreaList.length && <CircularProgress size={18} />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Grid>

        {/* Proofs Section */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Proofs</Typography>
          <Divider />
        </Grid>

       <Grid item xs={12} sm={6}>
  <Button variant="outlined" component="label" fullWidth>
    Upload ID Proof
    <input
      type="file"
      hidden
      accept=".pdf,.jpg,.jpeg,.png"
      onChange={handleFileUpload}
    />
  </Button>

  {fileError && (
    <Box sx={{ color: 'error.main', mt: 1 }}>
      {fileError}
    </Box>
  )}

  {idProofFile && (
    <Box sx={{ color: 'text.secondary', mt: 1 }}>
      Selected: {idProofFile.name}
    </Box>
  )}
</Grid>

<Grid item xs={12} sm={6}>
  <Button variant="outlined" component="label" fullWidth>
    Upload Address Proof
    <input
      type="file"
      hidden
      accept=".pdf,.jpg,.jpeg,.png"
      onChange={handleAddressProofUpload}
    />
  </Button>

  {addressProofError && (
    <Box sx={{ color: 'error.main', mt: 1 }}>
      {addressProofError}
    </Box>
  )}

  {addressProofFile && (
    <Box sx={{ color: 'text.secondary', mt: 1 }}>
      Selected: {addressProofFile.name}
    </Box>
  )}
</Grid>
        
      </Grid>

      {/* acn extra fields */}
      {companyEmail === 'acn@gmail.com' && (
  <>
  <Grid container spacing={2}>
    <Box
  sx={{
   
    borderColor: 'divider',
    borderRadius: 1,
    p: 2,
    mt: 4,
    
    backgroundColor: 'transparent'
  }}
>
   <Typography variant="h6" gutterBottom>
    Additional Customer Information
  </Typography>

  <Divider sx={{ mb: 2 }} /> 

  <Grid container spacing={2}>

    {/*
    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        label="Business"
        id="business"
        value={formValues.business}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        label="Customer Number"
        id="customerNumber"
        value={formValues.customerNumber}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        type="date"
        label="Date of Birth"
        id="dateOfBirth"
        value={formValues.dateOfBirth}
        onChange={handleChange}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        select
        fullWidth
        label="Gender"
        id="gender"
        name="gender"
        value={formValues.gender}
        onChange={(e) => {
    console.log('Gender Selected:', e.target.value);
    handleChange(e);
  }}
      >
        <MenuItem value="MALE">Male</MenuItem>
        <MenuItem value="FEMALE">Female</MenuItem>
        <MenuItem value="OTHER">Other</MenuItem>
      </TextField>
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        select
        fullWidth
        label="Agent"
        id="agent"
        name="agent"
        value={formValues.agent}
        onChange={handleChange}
      >
        /* {agentList?.map((agent) => (
          <MenuItem key={agent.id} value={agent.id}>
            {agent.name}
          </MenuItem>
        ))} 
      </TextField>
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        label="Roads"
        id="roads"
        value={formValues.roads}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        label="Buildings"
        id="buildings"
        value={formValues.buildings}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        label="Wing"
        id="wing"
        value={formValues.wing}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        label="Floor"
        id="floor"
        value={formValues.floor}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        label="Flat No"
        id="flatNo"
        value={formValues.flatNo}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        select
        fullWidth
        label="Member Type"
        id="memberType"
        name="memberType"
        value={formValues.memberType}
        onChange={handleChange}
      >
        <MenuItem value="OWNER">Owner</MenuItem>
        <MenuItem value="TENANT">Tenant</MenuItem>
        <MenuItem value="FAMILY">Family</MenuItem>
      </TextField>
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        label="Group"
        id="group"
        value={formValues.group}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        label="Postcode"
        id="postcode"
        value={formValues.postcode}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        label="GST No"
        id="gstNo"
        value={formValues.gstNo}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        label="PAN No"
        id="panNo"
        value={formValues.panNo}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        label="Latitude"
        id="latitude"
        value={formValues.latitude}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <TextField
        fullWidth
        label="Longitude"
        id="longitude"
        value={formValues.longitude}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={4}>
      <FormControlLabel
        control={
          <Switch
            checked={formValues.isRental || false}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                isRental: e.target.checked
              })
            }
          />
        }
        label="Is Rental"
        sx={{ mt: 1 }}
      />
    </Grid>

    <Grid item xs={12}>
      <TextField
        fullWidth
        multiline
        rows={3}
        label="Remarks"
        id="remarks"
        value={formValues.remarks}
        onChange={handleChange}
      />
    </Grid>
        */}
  </Grid>
</Box>
    <Box
  sx={{
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 1,
    p: 2,
    mt: 2,
    mb: 2,
    backgroundColor: 'transparent'
  }}
>
  <Typography variant="h6" gutterBottom>
    Billing Configuration
  </Typography>

  <Divider sx={{ mb: 2 }} />

  <Grid container spacing={2}>

    {/* Row 1 */}

    <Grid item xs={12} sm={2}>
      <FormControlLabel
        control={
          <Switch
            checked={formValues.prepaidCustomer}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                prepaidCustomer: e.target.checked
              })
            }
          />
        }
        label="Prepaid Customer"
      />
    </Grid>

    <Grid item xs={12} sm={2}>
  <TextField
    select
    fullWidth
    size="small"
    label="Billing Tax Type"
    id="billingTaxType"
    name="billingTaxType"
    value={formValues.billingTaxType}
    onChange={handleChange}
  >
    {billingTaxTypes.map((item) => (
      <MenuItem key={item.id} value={item.id}>
        {item.name}
      </MenuItem>
    ))}
  </TextField>
</Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        select
        fullWidth
        size="small"
        label="Bill Date"
        id="billDate"
        name="billDate"
        value={formValues.billDate}
        onChange={handleChange}
      >
        {[...Array(31)].map((_, i) => (
          <MenuItem key={i + 1} value={i + 1}>
            {i + 1}
          </MenuItem>
        ))}
      </TextField>
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        select
        fullWidth
        size="small"
        label="Due Date"
        id="dueDate"
        name="dueDate"
        value={formValues.dueDate}
        onChange={handleChange}
      >
        {[...Array(31)].map((_, i) => (
          <MenuItem key={i + 1} value={i + 1}>
            {i + 1}
          </MenuItem>
        ))}
      </TextField>
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        select
        fullWidth
        size="small"
        label="Service Person"
        id="servicePerson"
        name="servicePerson"
        value={formValues.servicePerson}
        onChange={handleChange}
      >
        <MenuItem value="ACN">ACN</MenuItem>
      </TextField>
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        select
        fullWidth
        size="small"
        label="Collection Person"
        id="collectionPerson"
        name="collectionPerson"
        value={formValues.collectionPerson}
        onChange={handleChange}
      >
        <MenuItem value="ACN">ACN</MenuItem>
      </TextField>
    </Grid>

    {/* Row 2 */}

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        type="date"
        size="small"
        label="Registration Date"
        id="registeredDate"
        name="registeredDate"
        value={
          formValues.registeredDate
            ? formValues.registeredDate.split("T")[0]
            : ""
        }
        onChange={(e) => {
          const date = e.target.value;

          setFormValues((prev) => ({
            ...prev,
            registeredDate: date ? `${date}T00:00:00` : null,
          }));
        }}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        type="date"
        size="small"
        label="Connection Date"
        id="connectionDate"
        name="connectionDate"
        value={
          formValues.connectionDate
            ? formValues.connectionDate.split("T")[0]
            : ""
        }
        onChange={(e) => {
          const date = e.target.value;

          setFormValues((prev) => ({
            ...prev,
            connectionDate: date ? `${date}T00:00:00` : null,
          }));
        }}
        InputLabelProps={{ shrink: true }}
      />
    </Grid>

    {/* <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        type="date"
        size="small"
        label="Connection Date"
        id="connectionDate"
        value={formValues.connectionDate}
        onChange={handleChange}
        InputLabelProps={{ shrink: true }}
      />
    </Grid> */}

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        size="small"
        label="Fix Bill Amount"
        id="fixBillAmount"
        value={formValues.fixBillAmount}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        select
        fullWidth
        size="small"
        label="Billing Type"
        id="billingType"
        name="billingType"
        value={formValues.billingType}
        onChange={handleChange}
      >
        <MenuItem value="MONTHLY">Monthly</MenuItem>
        <MenuItem value="QUARTERLY">Quarterly</MenuItem>
      </TextField>
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        size="small"
        label="Opening Amount"
        id="openingAmount"
        value={formValues.openingAmount}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        select
        fullWidth
        size="small"
        label="Opening Type"
        id="openingType"
        name="openingType"
        value={formValues.openingType}
        onChange={handleChange}
      >
        <MenuItem value="DEBIT">Debit</MenuItem>
        <MenuItem value="CREDIT">Credit</MenuItem>
      </TextField>
    </Grid>

    {/* Row 3 */}

    <Grid item xs={12} sm={2}>
      <FormControlLabel
        control={
          <Switch
            checked={formValues.isFree}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                isFree: e.target.checked
              })
            }
          />
        }
        label="Free"
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <FormControlLabel
        control={
          <Switch
            checked={formValues.isStb}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                isStb: e.target.checked
              })
            }
          />
        }
        label="Device"
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <FormControlLabel
        control={
          <Switch
            checked={formValues.isApk}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                isApk: e.target.checked
              })
            }
          />
        }
        label="APK"
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        select
        fullWidth
        size="small"
        label="Collection Date"
        id="collectionDate"
        name="collectionDate"
        value={formValues.collectionDate}
        onChange={handleChange}
      >
        {[...Array(31)].map((_, i) => (
          <MenuItem key={i + 1} value={i + 1}>
            {i + 1}
          </MenuItem>
        ))}
      </TextField>
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        size="small"
        label="One Time Charges"
        id="oneTimeCharges"
        value={formValues.oneTimeCharges}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        size="small"
        label="Security Deposit"
        id="securityDeposit"
        value={formValues.securityDeposit}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={2}>
      <TextField
        fullWidth
        size="small"
        label="Credit Limit"
        id="creditLimit"
        value={formValues.creditLimit}
        onChange={handleChange}
      />
    </Grid>

  </Grid>
</Box>
    </Grid>
  </>
)}
      {/* Action Buttons */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 2 }}>
        <Button onClick={handleClose} variant="outlined" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onSubmit} variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : 'Register Subscriber'}
        </Button>
      </Box>

      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <MuiAlert elevation={6} variant="filled" onClose={handleSnackbarClose}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </Box>
  );
};

export default AddUser;